/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomerJourneyQuestion } from './CustomerJourneyQuestion';
import {
	CustomerJourneyQuestionFromJSON,
	CustomerJourneyQuestionFromJSONTyped,
	CustomerJourneyQuestionToJSON,
	CustomerJourneyQuestionToJSONTyped,
} from './CustomerJourneyQuestion';

/**
 *
 * @export
 * @interface CaseQuestion
 */
export interface CaseQuestion {
	/**
	 *
	 * @type {string}
	 * @memberof CaseQuestion
	 */
	caseId?: string;
	/**
	 *
	 * @type {CustomerJourneyQuestion}
	 * @memberof CaseQuestion
	 */
	customerJourneyQuestion?: CustomerJourneyQuestion;
	/**
	 *
	 * @type {boolean}
	 * @memberof CaseQuestion
	 */
	isRequired?: boolean;
	/**
	 *
	 * @type {boolean}
	 * @memberof CaseQuestion
	 */
	answer?: boolean | null;
}

/**
 * Check if a given object implements the CaseQuestion interface.
 */
export function instanceOfCaseQuestion(value: object): value is CaseQuestion {
	return true;
}

export function CaseQuestionFromJSON(json: any): CaseQuestion {
	return CaseQuestionFromJSONTyped(json, false);
}

export function CaseQuestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseQuestion {
	if (json == null) {
		return json;
	}
	return {
		caseId: json['caseId'] == null ? undefined : json['caseId'],
		customerJourneyQuestion:
			json['customerJourneyQuestion'] == null
				? undefined
				: CustomerJourneyQuestionFromJSON(json['customerJourneyQuestion']),
		isRequired: json['isRequired'] == null ? undefined : json['isRequired'],
		answer: json['answer'] == null ? undefined : json['answer'],
	};
}

export function CaseQuestionToJSON(json: any): CaseQuestion {
	return CaseQuestionToJSONTyped(json, false);
}

export function CaseQuestionToJSONTyped(
	value?: CaseQuestion | null,
	ignoreDiscriminator: boolean = false
): any {
	if (value == null) {
		return value;
	}

	return {
		caseId: value['caseId'],
		customerJourneyQuestion: CustomerJourneyQuestionToJSON(value['customerJourneyQuestion']),
		isRequired: value['isRequired'],
		answer: value['answer'],
	};
}
